exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".home h1{margin-bottom:1em}.home .main{font-size:1.5rem;text-align:center}@media screen and (min-width: 1200px){.home .main{padding:0 2em}}\n", ""]);

